
import Vue from "vue";
import { mapState } from "vuex";
import { field001Asset } from "@/constants/field-001/assets";

export default Vue.extend({
  name: "Field001",
  computed: {
    ...mapState("app", {
      isMobile: "isMobile",
      oss: "oss"
    })
  },
  methods: {
    asset(filename: string) {
      return field001Asset(filename, this.oss);
    },
    onOpen(url: string) {
      window.open(url, "_blank");
    },
    copy(key: string) {
      return this.$t(`field001.${key}`);
    },
    hasCopy(key: string) {
      return this.$te(`field001.${key}`);
    }
  }
});
